import React from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { handleExternalLink } from "../../utils/ExternalLinksHelper";

const HelpAndSupportCard = ({ fields, containerClassName }) => {
    const renderFields = () => {
        return (
            fields &&
            fields.map((field, index) => {
                const fieldStructure = (
                    <button
                        className={`default-transparent-btn w-full block mb-2 ${
                            field.disabled ? "disabled" : ""
                        }`}
                        onClick={field.action && field.action}
                    >
                        <div className="flex items-center">
                            {field.icon && (
                                <i className={`${field.icon} mr-2`}></i>
                            )}
                            <span>{field.label}</span>
                        </div>
                    </button>
                );
                if ((field.path || field.url) && !field.disabled)
                    return (
                        <React.Fragment key={index}>
                            {field.url ? (
                                <span
                                    onClick={() =>
                                        handleExternalLink(field.url)
                                    }
                                >
                                    {fieldStructure}
                                </span>
                            ) : (
                                <Link to={field.path}>{fieldStructure}</Link>
                            )}
                        </React.Fragment>
                    );

                return (
                    <React.Fragment key={index}>
                        {fieldStructure}
                    </React.Fragment>
                );
            })
        );
    };
    return (
        <>
            <div className={`product-privacy-info ${containerClassName || ""}`}>
                <h4>
                    <Trans i18nKey="helpAndSupport">Help &amp; Support</Trans>
                </h4>
                {renderFields()}
            </div>
        </>
    );
};

export default HelpAndSupportCard;
